import React, { useState } from "react";
import { IPublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { IonApp, setupIonicReact } from "@ionic/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import Routes from "./routes/Routes";
import SelectedContext from "./contexts/SelectedContext";
import { formatDate } from "./utils";

// Mobiscroll stylsheet
import "@mobiscroll/react/dist/css/mobiscroll.min.css";

/* Core CSS required for Ionic components to work properly */
import "@ionic/react/css/core.css";

/* Basic CSS for apps built with Ionic */
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";

/* Optional CSS utils that can be commented out */
import "@ionic/react/css/padding.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/display.css";

/* Pymble brand theme (shared via pymble-ui) */
import "pymble-ui/theme.css";

/* App-specific overrides */
import "./theme/pymble.css";

import "./App.css";

setupIonicReact();

// Create a React Query client for our server state management
const queryClientApp = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 60 * 1, // 1 hour
      refetchOnWindowFocus: false,
    },
  },
});

const App: React.FC<{ msalInstance: IPublicClientApplication }> = ({ msalInstance }) => {
  const [selectedAbsenceDate, setSelectedAbsenceDate] = useState<string>(
    formatDate(new Date().toISOString())
  );
  const [firstDate, setFirstDate] = useState<string>(formatDate(new Date().toISOString()));
  const [lastDate, setLastDate] = useState<string>(formatDate(new Date().toISOString()));
  return (
    <>
      <QueryClientProvider client={queryClientApp}>
        <MsalProvider instance={msalInstance}>
          <SelectedContext.Provider
            value={{ selectedAbsenceDate, setSelectedAbsenceDate, firstDate, setFirstDate, lastDate, setLastDate }}
          >
            <IonApp>
              <Routes />
            </IonApp>
          </SelectedContext.Provider>
          <ReactQueryDevtools initialIsOpen={false} />
        </MsalProvider>
      </QueryClientProvider>
    </>
  );
};

export default App;
